"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createUseStorageState_1 = require("../createUseStorageState");

var useSessionStorageState = createUseStorageState_1.createUseStorageState(typeof window === 'object' ? window.sessionStorage : null);
exports["default"] = useSessionStorageState;